/* RUN LOCAL — race clock countdown */
class RlCountdown extends HTMLElement {
  connectedCallback() { this.render(); this.t = setInterval(() => this.render(), 30000); }
  disconnectedCallback() { clearInterval(this.t); }
  render() {
    const ms = new Date(this.dataset.to) - new Date();
    if (!(ms > 0)) { this.hidden = true; return; }
    const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
    const p = (n) => String(n).padStart(2, '0');
    this.setAttribute('aria-label', d + ' days ' + h + ' hours ' + m + ' minutes to the start');
    this.innerHTML = [['Days', p(d)], ['Hrs', p(h)], ['Min', p(m)]].map((u, i) => (i ? '<span class="rl-clock-sep" aria-hidden="true">:</span>' : '') + '<span class="rl-clock-unit"><span class="rl-stat">' + u[1] + '</span><span class="rl-clock-label">' + u[0] + '</span></span>').join('');
  }
}
if (!customElements.get('rl-countdown')) customElements.define('rl-countdown', RlCountdown);
